<div class="container">
  <div class="offset-sm-1 col-sm-10 pt-5 webview text-center" [@flyInOut]="'in'">
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question}}</h1>
    <div class="col-sm-6 col-md-6 col-xl-6 m-auto text-left">
      <label class="custom-control custom-checkbox chkbox mb-2" for="led1">
        <input type="checkbox" class="custom-control-input mgntp10" id="led1" value="None" name="led" [(ngModel)]="hgLeds.led_option1"
          (click)="getQuantity($event)" />
        <label class="custom-control-label font20" for="led1">None</label>
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="led2">
        <input type="checkbox" class="custom-control-input mgntp10" id="led2" value="Only the main lights"
          name="led" [(ngModel)]="hgLeds.led_option2" (click)="getQuantity($event)" />
        <label class="custom-control-label font20" for="led2">Only the main lights</label>
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="led3">
        <input type="checkbox" class="custom-control-input mgntp10" id="led3" value="All light fixtures"
          name="led" [(ngModel)]="hgLeds.led_option3" (click)="getQuantity($event)" />
        <label class="custom-control-label font20" for="led3">All light fixtures</label>
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="led4">
        <input type="checkbox" class="custom-control-input mgntp10" id="led4" value="What's LED?" name="led"
          [(ngModel)]="hgLeds.led_option4" (click)="getQuantity($event)" />
        <label class="custom-control-label font20" for="led4">What's LED?</label>
      </label>
    </div>
    <p class="m-0 mt-4 text-muted tapmsg">{{questionObj.chkboxtype}}</p>
    <button  *ngIf="showbutton" class="btn next mr-2 ml-2 disabledButton mt-2 font22 text-uppercase" [ngClass]="{'sectbtn': user_bot}"(click)="next();">Next</button>
    <!-- <p class="text-success mt-3" *ngIf="showTip">{{questionObj.tip}}</p> -->
    <div >
      <div class="mt-5">
        <div class="m-auto col-sm-10 col-md-6 col-xl-6 blockbg boxclr text-center">
          <img src="assets/images/flash.png" class="mb-1" />
          <p class="text-center tiphead">FUN FACT</p>
          <p class="text-center tipmes">{{questionObj.tip}}</p>
          <!-- <p class="text-center font-weight-bold">FUN FACT<br>
          <a class="font-weight-normal">{{questionObj.tip}}</a></p> -->
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container mobileview mt-2 px-0" [attr.id]="questionObj._id">
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
      <img style="width:100%;" src="assets/images/signimg.jpg" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box" >
        <h1 class="questionMob text-left">{{question}}</h1>
      </div>
    </div>
  </div>
  <div class="row col-sm-12 m-auto">
    <label class="custom-control custom-checkbox chkbox mb-2" for="led1_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="led1_mob" value="None" name="led" [(ngModel)]="hgLeds.led_option1"
        (click)="getQuantity($event)" />
      <label class="custom-control-label font20" for="led1_mob">None</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="led2_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="led2_mob" value="Only the main lights"
        name="led" [(ngModel)]="hgLeds.led_option2" (click)="getQuantity($event)" />
      <label class="custom-control-label font20" for="led2_mob">Only the main lights</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="led3_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="led3_mob" value="All light fixtures"
        name="led" [(ngModel)]="hgLeds.led_option3" (click)="getQuantity($event)" />
      <label class="custom-control-label font20" for="led3_mob">All light fixtures</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="led4_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="led4_mob" value="What's LED?" name="led"
        [(ngModel)]="hgLeds.led_option4" (click)="getQuantity($event)" />
      <label class="custom-control-label font20" for="led4_mob">What's LED?</label>
    </label>
    <p class="m-auto mt-4 text-muted tapmsg">{{questionObj.chkboxtype}}</p>
    <div style="width:97% !important; text-align: right;">
      <div *ngIf="user_bot" class="ash_box text-right mb-3" >
        <h1 class="ansMob text-right">{{number}}</h1>
      </div>
    </div>
    
    <div *ngIf="showTip">
      <div>
        <div class="m-auto col-sm-10 col-md-6 col-xl-4 blockbg boxclr">
          <img src="assets/images/flash.png" class="mb-1" style="margin-left: 48%" />
          <p class="text-center tiphead">FUN FACT</p>
          <p class="text-center tipmes">{{questionObj.tip}}</p>
          <!-- <p class="text-center font-weight-bold">FUN FACT<br>
            <a class="font-weight-normal">{{questionObj.tip}}</a></p> -->
        </div>
      </div>
    </div>
    
  </div>
  <!-- <div class="d-flex h-100 row col-sm-12 pr-0" *ngIf="showTyping">
    <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
      <img style="width:100%;" src="assets/images/signimg.jpg" />
    </div>
    <div class="col-sm-2 col-2 px-0 my-auto">
        <div class="arrow_box">
         <img class="p-2 pl-2 ml-1" src="assets/images/typing-animated-gif-4.gif" />
        </div>
    </div>
  </div> -->
</div>
<!-- <div class="btm-process webview">
  <div class="text-center">
    <span><img src="assets/images/active22.png"></span>
    <h4 class="clr333 processtxt">15% Completed</h4>
  </div>
</div> -->